// extracted by mini-css-extract-plugin
export default {"wrap":"Loading_wrap__+ekI5","loading":"Loading_loading__gqUsf"};